type Dependencies = {
  history?: History;
  location?: Location;
};

export function cleanup(di: Dependencies = {}): void {
  const {history = window.history, location = window.location} = di;
  history.replaceState(null, null, location.pathname);
}
